import ScrollToTop from '@/components/Base/ScrollToTop';
import MobileAppFrame from '@/components/layout/MobileAppFrame';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './stores/store';
import Router from './router';
import './assets/css/app.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <Provider store={store}>
      <MobileAppFrame>
        <Router />
      </MobileAppFrame>
    </Provider>
    <ScrollToTop />
  </BrowserRouter>
);
